import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu, Layout, Drawer, Tooltip, Popconfirm, notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faIndustry, faChartPie, faGear, faTags, faBagShopping, faCartShopping, faFileShield, faMessage, faThumbsUp, faBell, faSackDollar, faWarehouse, faCircleXmark, faUserTie, faAnglesLeft, faStar, faXmark } from '@fortawesome/free-solid-svg-icons';
import { cdnUrl } from '@Utils/cdnHelper';
import H3Image from '@Uilib/h3Image';
import TenantActions from '@Actions/tenantActions';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import { LoadingOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import UserActions from '@Actions/userActions';
import documentUINamesConstant from '../../../apis/documentUINamesConstant';

import * as FavoriteEntityModule from '../../../modules/favoriteEntity';
import { userMenuConstant } from '../../../apis/userMenu';

import './style.scss';

const { SubMenu } = Menu;
const { Sider } = Layout;

/**
 *
 */
class UserMenu extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      collapse: true,
      openKeys: [],
      documentUINames: {},
      favoriteEntityData: [],
    };
    this.debounceRef = null;
  }

  /**
   *
   */
  componentDidMount() {
    const {
      history, user, getTenants, favoriteEntity,
    } = this.props;
    const { currentPage } = this.state;
    if (user?.role_id === 10001) {
      getTenants(currentPage, '', true, user?.tenant_info?.org_id);
    }
    if (history.location.pathname) {
      this.setState({ currentPage: history.location.pathname });
    }
    if (history.location.pathname.includes('/inventory')) {
      this.setState({ openKeys: ['/inventory'] });
    }
    if (history.location.pathname.includes('/logistic')) {
      this.setState({ openKeys: ['/logistic'] });
    }
    if (history.location.pathname.includes('/production')) {
      this.setState({ openKeys: ['/production'] });
    }
    if (history.location.pathname.includes('/quality')) {
      this.setState({ openKeys: ['/quality'] });
    }
    if (history.location.pathname.includes('/settings')) {
      this.setState({ openKeys: ['/settings'] });
    }
    if (history.location.pathname.includes('/purchase') || history.location.pathname.includes('/approval')) {
      this.setState({ openKeys: ['/purchase'] });
    }
    if (history.location.pathname.includes('/payments')) {
      this.setState({ openKeys: ['/payments'] });
    }
    if (history.location.pathname.includes('/analytics')) {
      this.setState({ openKeys: ['/analytics'] });
    }
    if (history.location.pathname.includes('/sales')) {
      this.setState({ openKeys: ['/sales'] });
    }
    if (history.location.pathname.includes('/analytics')) {
      this.setState({ openKeys: ['/analytics'] });
    }

    const menuChildren = userMenuConstant(user)?.menuChildren || {};

    const isFavoritePath = favoriteEntity?.favorite_entity?.some(
      ({ entity_type }) => menuChildren[entity_type]?.key === history.location.pathname
    );

    if (isFavoritePath) {
      this.setState((prevState) => ({
        openKeys: [...prevState.openKeys, '/favorites'],
      }));
    }

    if (globalThis.plugSDK) {
      globalThis.plugSDK.onEvent((payload) => {
        if (payload.type === 'ON_PLUG_WIDGET_UNREAD_COUNT_CHANGE' && payload.value > 0) {
          globalThis.plugSDK.toggleWidget(true);
        }
      });
    }

  }

  getSubscriptionTitle() {
    const { user } = this.props;
    const enabledGlobalFeatures = user?.tenant_info?.global_config;
    const subscriptionEndDate = enabledGlobalFeatures?.settings?.next_renewal_date;
    const providedEndDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    const differenceInMilliseconds = providedEndDate - currentDate;
    const diffInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    return Math.floor(diffInDays);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.userReady) {
      props.getTenantsConfiguration(props.user?.tenant_info?.tenant_id);
      return {
        ...state,
        documentUINames: documentUINamesConstant(props.user),
        userReady: true,
      };
    }
    if (props.favoriteEntity && !state.favoriteEntityData?.length) {
      return {
        ...state,
        favoriteEntityData: props.favoriteEntity?.favorite_entity || [],
      };
    }
    return state;
  }

  /**
   *
   * @param {*} keys
   */
  onOpenChange = (keys) => {
    const key = keys.pop();
    this.setState({ openKeys: [key] });
  };

  renderMenu = (collapseable) => {
    const {
      user, org, favoriteEntity, getFavoriteEntity, removeFavoriteEntity, addFavoriteEntity, history
    } = this.props;
    const {
      currentPage, collapse, openKeys, documentUINames, showDrawer, iframeUrl, iframeLoaded, favoriteEntityData,
    } = this.state;
    const enabledInventoryFeatures = user?.tenant_info?.inventory_config;
    const enabledPurchaseFeatures = user?.tenant_info?.purchase_config;
    const enabledSalesFeatures = user?.tenant_info?.sales_config;
    const enabledProductionFeatures = user?.tenant_info?.production_config;
    const enabledQualityControlFeatures = user?.tenant_info?.quality_control_config;
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    const enabledLogisticsFeatures = user?.tenant_info?.logistics_config;

    const enabledGlobalFeatures = user?.tenant_info?.global_config;
    const subscriptionEndDate = enabledGlobalFeatures?.settings?.next_renewal_date;
    const providedEndDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    const differenceInMilliseconds = providedEndDate - currentDate;
    const diffInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const differenceInDays = Math.floor(diffInDays);

    const handleMenuClick = (url, type) => {
      this.setState({
        showDrawer: true, iframeUrl: url, iframeLoaded: false,
      });
    };

    const checkForPermissions = (permissionsEntities) => {
      if (permissionsEntities.length === 0) {
        return true;
      }

      let hasPermission = false;

      permissionsEntities.forEach((permissionEntity) => {
        if (Helpers.getPermission(
          permissionEntity,
          Helpers.permissionTypes.READ,
          user,
        )) {
          hasPermission = true;
        }
      });

      return hasPermission;
    };

    const visibleFavoriteEntity = ({ entities = [] }) => {
      const menuItems = [];

      if (!Array.isArray(entities) || entities.length === 0) return menuItems;

      const menuChildren = userMenuConstant(user)?.menuChildren || {};

      entities.forEach((entity) => {
        const entityData = menuChildren?.[entity?.entity_type];

        if (!entityData) return;

        const hasPermission = checkForPermissions(entityData?.permission_entity);
        const hasAddonPermission =
          entityData?.addon_permission_check?.has_permission ?? true;

        if (hasPermission && hasAddonPermission) {
          menuItems.push({ id: entity.id, ...entityData });
        }
      });

      return menuItems;
    };

    const debounce = (callback, delay) => {
      if (this.debounceRef) {
        clearTimeout(this.debounceRef);
      }

      this.debounceRef = setTimeout(() => {
        callback();
      }, delay);
    };

    const RenderFavoriteIcon = ({ entityType, setState }) => (
      favoriteEntityData?.some((entity) => entity.entity_type === entityType) ? (
        <Tooltip
          color="white"
          placement="right"
          title={
            <span style={{ color: 'black' }}> Remove from favorite </span>
          }
          arrow
          zIndex={1001}
        >
          <div onClick={(e) => {
            e.stopPropagation();
            const removedData = favoriteEntityData?.find((entity) => entity.entity_type === entityType);
            const remainingFavoriteEntities = favoriteEntityData.filter((entity) => entity.id !== removedData.id);
            setState(remainingFavoriteEntities);

            debounce(() => {
              removeFavoriteEntity({
                body: {
                  entity_type: removedData.entity_type,
                },
              }, (data) => {
                if (data.success) {
                  getFavoriteEntity({}, (favoriteEntities) => {
                    setState(favoriteEntities.data.favorite_entity);
                  });
                } else {
                  setState(favoriteEntity?.favorite_entity);
                }
              });
            }, 300);
          }}
          >
            <FontAwesomeIcon className="menu-item__favorite-icon menu-item__favorite-icon_marked" color="#efa83c" icon={faStar} />
          </div>

        </Tooltip>
      ) : (
        <Tooltip
          color="white"
          placement="right"
          title={
            <span style={{ color: 'black' }}> Mark as favorite </span>
          }
          arrow
          zIndex={1001}
        >
          <div onClick={(e) => {
            e.stopPropagation();
            if (favoriteEntityData?.length >= 5) {
              notification.open({
                type: 'warning',
                message: 'Maximum limit of 5 favorite entities reached.',
                duration: 4,
                placement: 'top',
              });
              return;
            }
            setState([...favoriteEntityData, { id: uuidv4(), entity_type: entityType }]);

            debounce(() => {
              addFavoriteEntity({
                body: {
                  entity_type: entityType,
                },
              }, (data) => {
                if (data.success) {
                  getFavoriteEntity({}, (favoriteEntities) => {
                    setState(favoriteEntities.data.favorite_entity);
                  });
                } else {
                  setState(favoriteEntity?.favorite_entity);
                }
              });
            }, 300);
          }}
          >
            <FontAwesomeIcon className="menu-item__favorite-icon menu-item__favorite-icon_unmarked" icon={faStar} />
          </div>
        </Tooltip>
      )
    );

    return (
      <div className="user-menu__wrapper-fixed">
        <Drawer
          open={showDrawer}
          onClose={() => this.setState({ showDrawer: false })}
          width="600px"
          destroyOnClose
          mask={false}
          className="header-right__help-drawer"
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '600px' }}>
              <H3Text text="Help Centre 👋" className="custom-drawer__title" />

              <div
                className="custom-drawer__close-icon"
                onClick={() => this.setState({ showDrawer: false })}
              >
                <FontAwesomeIcon icon={faCircleXmark} />
              </div>
            </div>
          </div>

          {/* Iframe to show selected content */}
          <iframe
            src={iframeUrl}
            onLoad={() => this.setState({ iframeLoaded: true })}
          />
          {!iframeLoaded && (
            <div className="header-right__help-drawer-loader">
              <LoadingOutlined />
            </div>
          )}
        </Drawer>
        <div
          style={{
            backgroundColor: 'white',
            zIndex: '10',
            position: 'fixed',
            width: '229px',
            marginTop: '-2px',
          }}
          onClick={() => history.push('/')}
        >
          {!user?.tenant_info?.global_config?.settings?.white_label_platform ? (
            <div className="user-menu__logo-fixed">
              {/* <img src="/favicon.ico" alt="Favicon" className="user-menu__logo" /> */}
              <div className="user-menu__logo-image-right-wrapper">
                <H3Image
                  src={cdnUrl('logo-without-tagline.png', 'images')}
                  className="user-menu__logo-image-right"
                />
              </div>
            </div>
          ) : (
            <div className="user-menu__logo-wl-fixed">
              <div className="user-menu__logo-image-left-wrapper">
                <H3Image
                  src={org?.organisation?.[0]?.logo}
                  className="user-menu__logo-image-left-mg__26 "
                />
              </div>
              <div className="user-menu__logo-image-right-wrapper">
                <div
                  className="user-menu__logo-image-right-header"
                >
                  Powered by
                </div>
                <H3Image
                  src={cdnUrl('logo-without-tagline.png', 'images')}
                  className="user-menu__logo-image-right"
                />
              </div>
            </div>
          )}
        </div>
        <div style={{ marginTop: '25px' }} className="scrollable-menu__wrapper">
          <Menu
            inlineCollapsed={collapse}
            selectedKeys={[currentPage]}
            defaultSelectedKeys={['/']}
            theme="light"
            onOpenChange={this.onOpenChange}
            openKeys={openKeys}
            onClick={(value) => {
              const { history } = this.props;
              history.push(value.key);
              this.setState({ currentPage: value.key });
            }}
            mode="inline"
            style={{
              padding: '0px !important',
              marginTop: '-10px',
            }}
          >
            <Menu.Item key="/" icon={<FontAwesomeIcon icon={faHouse} />}>
              Home
            </Menu.Item>
            {favoriteEntityData && favoriteEntityData.length > 0 && (
              <SubMenu key="/favorites" icon={<FontAwesomeIcon icon={faStar} />} title="Favorites">
                {visibleFavoriteEntity({ entities: favoriteEntityData }).map((item) => (
                  <Menu.Item key={item.key}>
                    <div className="user-menu__title-wrapper">
                      <span>{item.label}</span>
                      <div className="favorite-entity__menu-item_close">
                        <Popconfirm
                          title="Remove from favorite entity"
                          description="Are you sure to remove this entity?"
                          okText="Yes"
                          cancelText="No"
                          onPopupClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          onConfirm={() => {
                            this.setState((prevState) => {
                              const remainingFavoriteEntities = prevState.favoriteEntityData.filter((entity) => entity.id !== item.id);
                              return {
                                ...prevState,
                                favoriteEntityData: remainingFavoriteEntities,
                              };
                            });
                            removeFavoriteEntity({
                              body: {
                                entity_type: item.entity_type,
                              },
                            }, (data) => {
                              if (data.success) {
                                getFavoriteEntity({}, (favoriteEntities) => {
                                  this.setState({
                                    favoriteEntityData: favoriteEntities.data.favorite_entity,
                                  });
                                });
                              } else {
                                this.setState({ favoriteEntityData: favoriteEntity?.favorite_entity });
                              }
                            });
                          }}
                          zIndex={1001}
                        >
                          <FontAwesomeIcon
                            icon={faXmark}
                            color="#fe3f3f"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  </Menu.Item>
                ))}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/inventory" icon={<FontAwesomeIcon icon={faTags} />} title="Inventory">
                {Helpers.getPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/inventory/manage">
                      <div
                        className="user-menu__title-wrapper"
                      >
                        <span>Manage Products</span>
                        {!enabledInventoryFeatures?.sub_modules?.product?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.MANAGE_PRODUCT.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/inventory/tracking">
                      <div
                        className="user-menu__title-wrapper"
                      >
                        <span>Inventory Tracking</span>
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.INVENTORY_TRACKING.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/inventory/indent">
                      <div className="user-menu__title-wrapper">
                        <span> Stock Adjustment</span>
                        {!enabledInventoryFeatures?.sub_modules?.stock_adjustment?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.STOCK_ADJUSTMENT.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>

                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/inventory/stock-transfer">
                      <div className="user-menu__title-wrapper">
                        <span>Stock Transfer</span>
                        {!enabledInventoryFeatures?.sub_modules?.stock_transfer?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.STOCK_TRANSFER.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/inventory/delivery-challan">
                      <div className="user-menu__title-wrapper">
                        <span>Delivery Challan</span>
                        {!enabledInventoryFeatures?.sub_modules?.delivery_challan?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.DELIVERY_CHALLAN.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>

                    </Menu.Item>
                  )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.GATE_DOCUMENT, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/logistic" icon={<FontAwesomeIcon icon={faWarehouse} />} title="Logistics">
                {Helpers.getPermission(Helpers.permissionEntities.GATE_DOCUMENT, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/logistic/gate-document">
                    <div className="user-menu__title-wrapper">
                      <span>Gate Document</span>
                      {!enabledLogisticsFeatures?.sub_modules?.gate_document?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.GATE_DOCUMENT.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/purchase" icon={<FontAwesomeIcon icon={faCartShopping} />} title="Purchase">
                {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/vendors/manage">
                    <div className="user-menu__title-wrapper">
                      <span>Vendors</span>
                      {!enabledPurchaseFeatures?.sub_modules?.vendor?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.VENDORS.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/purchase-request">
                    <div className="user-menu__title-wrapper">
                      <span>Material Requests</span>
                      {!enabledPurchaseFeatures?.sub_modules?.purchase_request?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.PURCHASE_REQUEST.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/purchase-indent">
                    <div className="user-menu__title-wrapper">
                      <span>Purchase Indent</span>
                      {!enabledPurchaseFeatures?.sub_modules?.purchase_indent?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.PURCHASE_INDENT.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/rfq">
                    <div className="user-menu__title-wrapper">
                      <span>Request for Quotation</span>
                      {!enabledPurchaseFeatures?.addons?.request_for_quotation?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.REQUEST_FOR_QUOTATION.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/purchase-orders">
                    <div className="user-menu__title-wrapper">
                      <span>Purchase Orders</span>
                      {!enabledPurchaseFeatures?.sub_modules?.purchase_order?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.PURCHASE_ORDER.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/goods-receiving">
                    <div className="user-menu__title-wrapper">
                      <span>Goods Receiving</span>
                      {!enabledPurchaseFeatures?.sub_modules?.goods_receiving_note?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.GOOD_RECEIVING.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/account-payable-invoice">
                    <div className="user-menu__title-wrapper">
                      <span>AP Invoice</span>
                      {!enabledPurchaseFeatures?.sub_modules?.account_payable_invoice?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.ACCOUNT_PAYABLE_INVOICE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/debit-notes">
                    <div className="user-menu__title-wrapper">
                      <span>Debit Notes</span>
                      {!enabledPurchaseFeatures?.sub_modules?.debit_note?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.DEBIT_NOTE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/vendor-payouts">
                    <div className="user-menu__title-wrapper">
                      <span>Outgoing Payments</span>
                      {!enabledPurchaseFeatures?.sub_modules?.payment_outgoing?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.OUTGOING_PAYMENT.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.EXPENSES, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/expense">
                    <div className="user-menu__title-wrapper">
                      <span>Expenses</span>
                      {!enabledPurchaseFeatures?.addons?.expense?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.EXPENSES.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.MRP, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/production" icon={<FontAwesomeIcon icon={faIndustry} />} title="Production">
                {Helpers.getPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/bom">
                      <div className="user-menu__title-wrapper">
                        <span>Bill of Materials</span>
                        {!enabledProductionFeatures?.sub_modules?.bill_of_material?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.BOM.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {(Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.PRODUCTION_SCHEDULING, Helpers.permissionTypes.READ, user))
                  && (
                    <Menu.Item key="/production/manufacturing-orders">
                      <div className="user-menu__title-wrapper">
                        <span> Manufacturing Orders</span>
                        {!enabledProductionFeatures?.sub_modules?.manufacturing_order?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.MANUFACTURING_ORDER.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}

                {Helpers.getPermission(Helpers.permissionEntities.PRODUCTION_SCHEDULING, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/schedules">
                      <div className="user-menu__title-wrapper">
                        <span> Schedules</span>
                        {!enabledProductionFeatures?.sub_modules?.scheduling?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.SCHEDULES.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}

                {Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/manual-entry">
                      <div className="user-menu__title-wrapper">
                        <span>Manual Entry</span>
                        {!enabledProductionFeatures?.sub_modules?.manufacturing_order?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.MANUAL_ENTRY.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/job-works">
                      <div className="user-menu__title-wrapper">
                        <span>Job Cards</span>
                        {!enabledProductionFeatures?.addons?.job_card?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.JOB_CARD.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.MRP, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/planning/v2">
                      <div className="user-menu__title-wrapper">
                        <span>Materials Planning</span>
                        {!enabledProductionFeatures?.addons?.material_planing?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.MRP.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key="/production/configurations">
                      <div className="user-menu__title-wrapper">
                        <span>Factory Setup</span>
                        {!enabledProductionFeatures?.addons?.factory_setup?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.FACTORY_SETUP.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.IN_PROCESS_QUALITY_CONTROL_RULE, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.IN_PROCESS_QUALITY_CHECK, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.PDI_CHECK, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/quality" icon={<FontAwesomeIcon icon={faFileShield} />} title="Quality Control">
                {(Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.IN_PROCESS_QUALITY_CONTROL_RULE, Helpers.permissionTypes.READ, user)) && (
                  <Menu.Item key="/quality/quality-control-points">
                    <div className="user-menu__title-wrapper">
                      <span>Quality Rules</span>
                      {(!enabledQualityControlFeatures?.sub_modules?.quality_control_rule?.is_active && !enabledQualityControlFeatures?.sub_modules?.in_process_quality_control_rule?.is_active) ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.QUALITY_RULES.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {(Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.IN_PROCESS_QUALITY_CHECK, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.PDI_CHECK, Helpers.permissionTypes.READ, user)) && (
                  <Menu.Item key="/quality/quality-checks">
                    <div className="user-menu__title-wrapper">
                      <span> Quality Checks</span>
                      {(!enabledQualityControlFeatures?.sub_modules?.quality_check?.is_active && !enabledQualityControlFeatures?.sub_modules?.in_process_quality_check?.is_active && !enabledQualityControlFeatures?.sub_modules?.pre_dispatch_inspection_check?.is_active) ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.QUALITY_CHECKS.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/sales" icon={<FontAwesomeIcon icon={faBagShopping} />} title="Sales">
                {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/customers">
                    <div className="user-menu__title-wrapper">
                      <span>Customers</span>
                      {!enabledSalesFeatures?.sub_modules?.customer?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.CUSTOMER.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.SALES_ESTIMATE, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/estimate">
                    <div className="user-menu__title-wrapper">
                      <span>{`${documentUINames?.estimateUIName || 'Estimate'}s`}</span>
                      {!enabledSalesFeatures?.sub_modules?.sales_estimate?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.ESTIMATE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {(Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user)) && (
                  <Menu.Item key="/sales/sales-orders">
                    <div className="user-menu__title-wrapper">
                      <span>{`${documentUINames?.salesOrderUIName || 'Sales Order'}s`}</span>
                      {!enabledSalesFeatures?.sub_modules?.sales_order?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.SALES_ORDER.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/packing-slips">
                    <div className="user-menu__title-wrapper">
                      <span>Packing Slip</span>
                      {!enabledSalesFeatures?.sub_modules?.packing_slip?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.PACKING_SLIP.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/invoices">
                    <div className="user-menu__title-wrapper">
                      <span>Invoices</span>
                      {!enabledSalesFeatures?.sub_modules?.invoice?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.INVOICE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/consumption">
                    <div className="user-menu__title-wrapper">
                      <span>Consumption Orders</span>
                      {/* TODO here also update is_active key with new entity */}
                      {!enabledSalesFeatures?.sub_modules?.consumption_order?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.CONSUMPTION_ORDER.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/credit-notes">
                    <div className="user-menu__title-wrapper">
                      <span>Credit Notes</span>
                      {!enabledSalesFeatures?.sub_modules?.credit_note?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.CREDIT_NOTE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.RETURN_SLIP, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/return-slips">
                    <div className="user-menu__title-wrapper">
                      <span>Return Slips</span>
                      {!enabledSalesFeatures?.sub_modules?.return_slip?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.RETURN_SLIP.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {
                  Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user) && (
                    <Menu.Item key="/sales/incoming-payments">
                      <div className="user-menu__title-wrapper">
                        <span>Incoming Payments</span>
                        {!enabledSalesFeatures?.sub_modules?.payment_incoming?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.INCOMING_PAYMENTS.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )
                }
                {Helpers.getPermission(Helpers.permissionEntities.E_WAY_BILL, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/sales/ewaybill">
                    <div className="user-menu__title-wrapper">
                      <span>e-Way Bills</span>
                      {!enabledSalesFeatures?.addons?.e_waybill?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.E_WAY_BILL.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
            {(Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user) || user?.tenant_info?.it_id) && (
              <SubMenu key="/integrations" icon={<FontAwesomeIcon icon={faSackDollar} />} title="Accounting">
                {user?.tenant_info?.it_id && (
                  <Menu.Item key="/integration/tally">
                    <div className="user-menu__title-wrapper">
                      <span>
                        Tally Sync
                      </span>
                      <RenderFavoriteIcon
                        entityType={userMenuConstant(user).menuChildren.TALLY_SYNC.entity_type}
                        setState={(data) => {
                          this.setState({
                            favoriteEntityData: data,
                          });
                        }}
                      />
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/purchase/vendor-payouts">
                    <div className="user-menu__title-wrapper">
                      <span>Outgoing Payments</span>
                      {!enabledPurchaseFeatures?.sub_modules?.payment_outgoing?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.OUTGOING_PAYMENT.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {
                  Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user) && (
                    <Menu.Item key="/sales/incoming-payments">
                      <div className="user-menu__title-wrapper">
                        <span>Incoming Payments</span>
                        {!enabledSalesFeatures?.sub_modules?.payment_incoming?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.INCOMING_PAYMENTS.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )
                }
              </SubMenu>
            )}
            <SubMenu key="/analytics" icon={<FontAwesomeIcon icon={faChartPie} />} title="Analytics">
              {Helpers.getPermission(Helpers.permissionEntities.REPORTS, Helpers.permissionTypes.READ, user) && (
                <Menu.Item key="/analytics/newReports/v2">
                  <div className="user-menu__title-wrapper">
                    <span>
                      Reports
                      &nbsp;
                      {/* <span className="user-menu__title-beta">New</span> */}
                    </span>
                    <RenderFavoriteIcon
                      entityType={userMenuConstant(user).menuChildren.REPORTS.entity_type}
                      setState={(data) => {
                        this.setState({
                          favoriteEntityData: data,
                        });
                      }}
                    />
                  </div>
                </Menu.Item>
              )}
              {/* {(
                <Menu.Item key="/analytics/forecasting">
                  <div className="user-menu__title-wrapper">
                    <span>Demand Forecasting</span>
                    {!user?.tenant_info?.global_config?.sub_modules?.demand_forecasting?.is_active && (
                      <H3Image src={cdnUrl("crown2.png", "images")} className="user-menu__crown" />
                    )}
                  </div>
                </Menu.Item>
              )} */}
              <Menu.Item key="/analytics/bulkUpload">
                <div className="user-menu__title-wrapper">
                  <span>
                    Bulk Uploads
                  </span>
                  <RenderFavoriteIcon
                    entityType={userMenuConstant(user).menuChildren.BULK_UPLOAD.entity_type}
                    setState={(data) => {
                      this.setState({
                        favoriteEntityData: data,
                      });
                    }}
                  />
                </div>
              </Menu.Item>
            </SubMenu>
            {(Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.READ, user)) && (
              <SubMenu key="/settings" icon={<FontAwesomeIcon icon={faGear} />} title="Settings">
                {(Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) || Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user))
                  && (
                    <Menu.Item key="/settings/team">
                      <div className="user-menu__title-wrapper">
                        <span>
                          Manage Team
                        </span>
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.MANAGE_TEAM.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.READ, user) && (
                  <Menu.Item key="/settings/workflow">
                    <div className="user-menu__title-wrapper">
                      <span>Approvals Setup</span>
                      {!user?.tenant_info?.global_config?.sub_modules?.approval_workflow?.is_active ? (
                        <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                      ) : (
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.APPROVALS_SETUP.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      )}
                    </div>
                  </Menu.Item>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user)
                  && (
                    <Menu.Item key={Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.UPDATE, user) ? '/settings/business-profile' : '/settings/business-profile?tab=/my-profile'}>
                      <div className="user-menu__title-wrapper">
                        <span>
                          Business
                          Profile
                        </span>
                        <RenderFavoriteIcon
                          entityType={userMenuConstant(user).menuChildren.BUSINESS_PROFILE.entity_type}
                          setState={(data) => {
                            this.setState({
                              favoriteEntityData: data,
                            });
                          }}
                        />
                      </div>
                    </Menu.Item>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) && enabledWarehouseLocations
                  && (
                    <Menu.Item key="/settings/warehouse-setup">
                      <div className="user-menu__title-wrapper">
                        <span>Warehouse Setup</span>
                        {!user?.tenant_info?.global_config?.sub_modules?.warehouse_setup?.is_active ? (
                          <H3Image src={cdnUrl('crown2.png', 'images')} className="user-menu__crown" />
                        ) : (
                          <RenderFavoriteIcon
                            entityType={userMenuConstant(user).menuChildren.WAREHOUSE_SETUP.entity_type}
                            setState={(data) => {
                              this.setState({
                                favoriteEntityData: data,
                              });
                            }}
                          />
                        )}
                      </div>
                    </Menu.Item>
                  )}
              </SubMenu>
            )}
            {user?.org_id && user?.tenant_info && <Menu.Item key="/admin/business-units" icon={<FontAwesomeIcon icon={faUserTie} />} style={{ color: '#2D7DF7 !important' }}>Switch to Admin</Menu.Item>}
          </Menu>
        </div>

        <div
          className="user-menu__bottom"
          style={{
            paddingBottom: differenceInDays > -30 && differenceInDays < 15 ? '50px' : '0px',
          }}
        >
          <Menu
            inlineCollapsed={false}
            theme="light"
            mode="inline"
            style={{
              padding: '0px !important',
              marginTop: 'auto',
            }}
          >
            <Menu.Item
              key="whatsapp-new"
              icon={(
                <img
                  src={cdnUrl('whatsapp.png', 'images')}
                  alt="WhatsApp"
                  style={{ width: '17px', height: '17px', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents triggering the main menu click
                    window.open('https://www.whatsapp.com/channel/0029Vb1fE9RD8SE36GMYEV0S');
                  }}
                />
              )}
              onClick={() => window.open('https://www.whatsapp.com/channel/0029Vb1fE9RD8SE36GMYEV0S')}
            >
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                What's new in Procuzy?
                {/* <div className="circles" style={{ pointerEvents: 'none' }}>
                  <div className="circle1" />
                  <div className="circle2" />
                  <div className="circle3" />
                </div> */}
                <span id="fb-update-badge" />
              </div>
            </Menu.Item>
            <Menu.Item
              key="whats-new"
              icon={<FontAwesomeIcon icon={faBell} />}
              onClick={() => window.open('https://procuzy.notion.site/procuzy-app-change-logs')}
            >
              What's New
              <span id="fb-update-badge" />
            </Menu.Item>
            <Menu.Item
              key="feedback"
              icon={<FontAwesomeIcon icon={faThumbsUp} />}
              onClick={() => handleMenuClick('https://scribehow.com/page/Procuzy_Usage_Guide___SJJ4sCglSIC0MHRH8zT1pw')}
            >
              Help Center
            </Menu.Item>
            <Menu.Item
              key="/contact"
              icon={<FontAwesomeIcon icon={faMessage} />}
              onClick={() => {
                globalThis.plugSDK.toggleWidget(true);
              }}
              className="chat-button"
            >
              Chat with us
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.handleMenubarStyleChange();
              }}
            >
              <FontAwesomeIcon icon={faAnglesLeft} style={{ marginLeft: '77px' }} />
            </Menu.Item>
          </Menu>
        </div>

      </div>
    );
  }

  handleMenubarStyleChange = () => {
    const { updateMyUser, getUserProfile, setMenuConfig } = this.props;
    updateMyUser({ side_menu_bar_type: 'COLLAPSIBLE', hideNotification: true }, () => {
      setMenuConfig('COLLAPSIBLE');
      localStorage.setItem('user_menu_config', JSON.stringify('COLLAPSIBLE'));
    });
  }

  render() {
    const {
      currentPage, collapse, openKeys,
    } = this.state;
    return (
      <Fragment>
        <div className={`user-menu-fixed ${Helpers.hasExpiryNotification() ? 'user-menu-with-notification' : ''}`}>
          <Sider
            width="230px"
            onCollapse={() => this.setState({ collapse: !collapse })}
          >
            {this.renderMenu(true)}
          </Sider>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers, GetFavoriteEntity, AddFavoriteEntity, RemoveFavoriteEntity,
}) => ({
  user: UserReducers.user,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  org: UserReducers.org,
  favoriteEntity: GetFavoriteEntity.data,
  favoriteEntityLoading: GetFavoriteEntity.loading,
  addFavoriteEntityLoading: AddFavoriteEntity.loading,
  removeFavoriteEntityLoading: RemoveFavoriteEntity.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  updateMyUser: (payload, callback) => dispatch(UserActions.updateMyUser(payload, callback)),
  getFavoriteEntity: (payload, callback) => dispatch(FavoriteEntityModule.GetFavoriteEntity.actions.request(payload, callback)),
  addFavoriteEntity: (payload, callback) => dispatch(FavoriteEntityModule.AddFavoriteEntity.actions.request(payload, callback)),
  removeFavoriteEntity: (payload, callback) => dispatch(FavoriteEntityModule.RemoveFavoriteEntity.actions.request(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserMenu));
